import numeral from 'numeral'

export default input => numeral(input).format('$ 0,0.00').replace(',00', '')